(function(){
  'use strict';

  angular.module("tfc.retailer.CategorySelection")
      .directive('categoryDropdown',categoryDropdown)
      .controller('categoryDropdownCtrl',categoryDropdownCtrl)
      .constant('categoryDropdownCfg', {
        display: 'DropDown',
        LOW:-10,
        HIGH:10
      });

  //ngInject
  function categoryDropdownCtrl ($scope, $element, $attrs ,categoryDropdownCfg){
    var ngModelCtrl, self = this;
    this.init = function(_ngModelCtrl){
      ngModelCtrl = _ngModelCtrl;
      ngModelCtrl.$render = function(){
        if(!_.isUndefined($scope.selectedCategory)){
          ngModelCtrl.$setViewValue($scope.selectedCategory);
        }

        self.$render(ngModelCtrl.$viewValue);
      };
    };


    $scope.selectItem = function(item){
      var itemObj = item;
      if(_.isObject(item)){
        $scope.selectedCategory = itemObj;

        ngModelCtrl.$render();
      }
    };

    $scope.getKeyColor = function (dist) {
      var colorClass = "";
      if (dist == "") {
        colorClass = 'one-retailer-color-key';
      }else if ( dist >= categoryDropdownCfg.HIGH ) {
        colorClass = 'high-color-key';
      }else if ( categoryDropdownCfg.HIGH > dist && dist >= categoryDropdownCfg.LOW ) {
        colorClass = 'medium-color-key';
      }else if ( dist < categoryDropdownCfg.LOW ) {
        colorClass = 'low-color-key';
      }
      return colorClass;
    }
  };

  //ngInject
  function categoryDropdown(categoryDropdownCfg){
    return{
      restrict: "AE",
      scope:{
        categoryDropdownItems: "="
      },
      require: ['categoryDropdown','ngModel'],
      controller: "categoryDropdownCtrl",
      templateUrl: 'Util/CategorySelection/CategorySelection.tmpl.html',
      link: function(scope, el, attr, ctrls){
        var categoryDropdownCtrl = ctrls[0], ngModelCtrl = ctrls[1];
        var defaultDisplay = (attr.categoryDropdownDisplay && attr.categoryDropdownDisplay != "") ?
            JSON.parse(attr.categoryDropdownDisplay):categoryDropdownCfg.display;

        scope._categoryDropdownItems = scope.categoryDropdownItems;

        categoryDropdownCtrl.init(ngModelCtrl);
        categoryDropdownCtrl.$render = function(displayObj){
          changeShowText(displayObj);
        };

        categoryDropdownRender();

        function categoryDropdownRender(){
          changeShowText(defaultDisplay);
        }

        function changeShowText(displayObj){
          scope.selectedCategory = (displayObj !== null) ? displayObj : defaultDisplay;
        }
      }
    };
  };
})();